/**
 * @file Handles atyle configuration for the ahdWeb-projects.
 * @author Phillip Kühn
 */
import { type DeepPartial } from 'react-hook-form';

import { type ConfigObject } from './types';

const configAhdWeb: DeepPartial<ConfigObject> = {
    module: {
        aktionsslider: true,
        erweiterteSchnellsuche: true,
        fahrzeugliste: true,
        fahrzeugslider: true,
        fahrzeugsuche: true,
        finanzierungsansicht: true,
        schnellsuche: true,
        standorte: true,
    },
    contact: {
        linkDisclaimer: '/datenschutz',
    },
    fahrzeugsuche: {
        hideFooterAutohausDigitalLink: true,
        hideHeading: true,
    },
    schnellsuche: {
        noBorderPadding: true,
    },
    style: {
        borderRadius: 2,
        fontSize: 15,
        scrollOffset: 100,
    },
};

export default configAhdWeb;
